// src/hooks/useUsers.js
import { useState, useEffect } from 'react';
import { collection, onSnapshot, doc, deleteDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'customerProfiles'),
      (snapshot) => {
        const data = snapshot.docs.map((docSnap) => {
          const d = docSnap.data();
          return {
            id: docSnap.id,
            firstName: d.firstName || '',
            lastName: d.lastName || '',
            email: d.email || '',
            phone: d.phone || '',
            address: d.address || '',
            notes: d.notes || '',
            totalSpent: d.totalSpent || 0,
            services: d.services || [],
            joinDate: d.createdAt
              ? (d.createdAt.toDate ? d.createdAt.toDate().toISOString().split('T')[0] : new Date(d.createdAt).toISOString().split('T')[0])
              : new Date().toISOString().split('T')[0],
          };
        });
        setUsers(data);
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching customerProfiles:', err);
        setError('Failed to load customers');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const getUserById = (userId) => users.find((u) => u.id === userId);

  const updateUser = async (userId, updateData) => {
    setError(null);
    try {
      await updateDoc(doc(db, 'customerProfiles', userId), {
        ...updateData,
        updatedAt: new Date(),
      });
      return { success: true };
    } catch (err) {
      console.error('Error updating customer:', err);
      const errorMessage = err.message || 'Failed to update customer';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  const deleteUser = async (userId) => {
    setError(null);
    try {
      await deleteDoc(doc(db, 'customerProfiles', userId));
      return { success: true };
    } catch (err) {
      console.error('Error deleting customer:', err);
      const errorMessage = err.message || 'Failed to delete customer';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  const getUserStats = () => ({
    totalUsers: users.length,
    totalRevenue: users.reduce((sum, u) => sum + u.totalSpent, 0),
  });

  return {
    users,
    loading,
    error,
    getUserById,
    updateUser,
    deleteUser,
    getUserStats,
    setError,
  };
};

export default useUsers;